import { Skeleton } from "@/shadcn/ui/skeleton";

// Loading skeleton for comedian cards
export function ComedianCardSkeleton() {
  return (
    <div className="flex flex-col space-y-3 animate-in fade-in-50 duration-300">
      <Skeleton className="h-48 w-full rounded-lg bg-gray-200" />
      <Skeleton className="h-4 w-3/4 bg-gray-200" />
      <Skeleton className="h-4 w-1/2 bg-gray-200" />
      <Skeleton className="h-8 w-full rounded-md bg-gray-200" />
    </div>
  );
}

// Loading skeleton for show cards
export function ShowCardSkeleton() {
  return (
    <div className="flex items-center space-x-4 p-4 border rounded-lg animate-in fade-in-50 duration-300">
      <Skeleton className="h-16 w-16 rounded-full bg-gray-200" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-1/3 bg-gray-200" />
        <Skeleton className="h-3 w-1/2 bg-gray-200" />
        <Skeleton className="h-3 w-2/3 bg-gray-200" />
      </div>
      <Skeleton className="h-10 w-24 rounded-md bg-gray-200" />
    </div>
  );
}
